// Generated from SVG to Code Figma Plugin

export const App = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect height="19.5" width="13.5" rx="3.42857" stroke="currentColor" strokeWidth="1.5" x="5.25" y="2.25" />
    <path d="M10.5 18H13.5" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
  </svg>
);
